import { UUID } from "crypto";

/**
 * Partner menu query key factory
 */
export const partnerMenuKeys = {
  all: ["partnerMenu"] as const,
  // Menu items for a partner
  partnerMenuItems: (partnerId: UUID) =>
    [...partnerMenuKeys.all, "items", partnerId] as const,
  // Single menu item with products
  menuItem: (menuItemId: UUID) =>
    [...partnerMenuKeys.all, "item", menuItemId] as const,
  // Products for a menu item
  menuItemProducts: (menuItemId: UUID) =>
    [...partnerMenuKeys.all, "products", menuItemId] as const,
} as const;
